import currenciesMap from '../currencies';
import mapKeys from "lodash/mapKeys";

export class MoneyFormatter {
  constructor(options){
    const { allowNegative, thousandSeparator, } = options || {};

    this.allowNegative = allowNegative;
    this.thousandSeparator = thousandSeparator;
  }

   allowNegative;
   thousandSeparator;

   format(value, currency, showCurrency ) {
    const { allowNegative, thousandSeparator } = this;

    return MoneyFormatter.format(value, currency, showCurrency, {
      allowNegative,
      thousandSeparator,
    });
  }

   unformat(value) {
    if (this.thousandSeparator) {
      return this._removeThousandsSeparators(value, this.thousandSeparator);
    }

    return value;
  }

  /**
   * Removes thousands separators
   */
   _removeThousandsSeparators(str, separator) {
    return str.split(separator).join("");
  }



  //========================Static part============================
   static format(value, currency = '', showCurrency = false, options) {
    if (!value) {
      return value;
    }
    currency = typeof currency === 'string' ? currency.toLowerCase() : null;


    if(typeof value !== 'string') value = value.toString()
    if(value.toString().indexOf('e') !== -1){
      value = this._exponentialToNumber(value.toString())
    }

    const { allowNegative, thousandSeparator } = options

    const currencies =
    currenciesMap && currenciesMap.length
      ? currenciesMap.map(cur => mapKeys(cur, (value, key) => key.toLowerCase()))
      : null;

    const currencyObj =
      currencies && currency ? currencies.find(el => el.hasOwnProperty(currency)) : null;

    const precision = currencyObj ? currencyObj[currency] : this._getPrecision(value.toString().split(' ')[0]);
    

    let sign = "";

    if (allowNegative && value.charAt(0) === "-") {
      sign = "-";
    }

    value = this._removeIllegalChars(value);
    value = this._removeExcessPoints(value);
    value = this._cutToPrecision(value, precision);
    value = this._setZeroAtStart(value);

    if (thousandSeparator) {
      value = this._setThousandsSeparators(value, thousandSeparator);
    }

    value = sign + value;

    if(showCurrency && currency) value = `${value} ${currency.toUpperCase()}`

    return value;
  }

  /* Adds zero to the beginning of string if num does not have an integer part.
   * Removes extra zeros in start of the the integer part
   */
   static _setZeroAtStart(str) {
    if (str.charAt(0) === ".") {
      return "0" + str;
    }

    if (str.charAt(0) === "0" && str.length !== 1) {
      //count zero at string start
      const chars = str.split("");
      let zeroCount = 0;
      for (let i = 0; i < chars.length; i++) {
        const char = chars[i];
        if (char === "0") {
          zeroCount++;
        } else if (char === ".") {
          zeroCount--;
          break;
        } else {
          break;
        }
      }

      return chars.slice(zeroCount).join("") || "0";
    }

    return str;
  }

  static _getPrecision(value) {
    if (value.indexOf('e') !== -1) value = this._exponentialToNumber(value)
    var separator = (1.1).toString().split('1')[1];
    
    const [integer, float] = value.split(separator);
    if(float){
       return float.length > 2 ? float.length : 2
    }else{
      return 2
    }
  }

  static _exponentialToNumber(n){
    var sign = +n < 0 ? "-" : "",
    toStr = n.toString();
    if (!/e/i.test(toStr)) {
        return n;
    }
    var [lead,decimal,pow] = n.toString()
        .replace(/^-/,"")
        .replace(/^([0-9]+)(e.*)/,"$1.$2")
        .split(/e|\./);
    return +pow < 0 
        ? sign + "0." + "0".repeat(Math.max(Math.abs(pow)-1 || 0, 0)) + lead + decimal
        : sign + lead + (+pow >= decimal.length ? (decimal + "0".repeat(Math.max(+pow-decimal.length || 0, 0))) : (decimal.slice(0,+pow)+"."+decimal.slice(+pow)))
  }

  /**
   * Sets thousands separators for integer and fractional parts of num
   */
   static _setThousandsSeparators(str, separator) {
    return str
      .split(".")
      .map((s) => this._addThousandsSeparators(s, separator))
      .join(".");
  }

  /**
   * Sets thousands separators to num
   */
   static _addThousandsSeparators(str, separator) {
    const thousands = Math.ceil(str.length / 3);

    if (thousands > 1) {
      const reversedChars = str.split("").reverse();

      for (let i = 1; i < thousands; i++) {
        const currentI = i * 3 - 1;
        reversedChars[currentI] = separator + reversedChars[currentI];
      }

      return reversedChars.reverse().join("");
    }

    return str;
  }

  /**
   * Cuts fractional part to setted precision
   */
   static _cutToPrecision(str, precision) {
    if(str.indexOf('.') === -1) str =  str + '.'
    return str
      .split(".")
      .map((el, index) => {
        if (index === 1) {
          return el.slice(0, precision).padEnd(precision, '0');
        }
      
        return el;
      })
      .join(".");
  }

  /**
   * Removes illegal chars from string
   */
   static _removeIllegalChars(str) {
    return str
      .split("")
      .filter((char) => /\d|\./.test(char))
      .join("");
  }

  /**
   * Removes all dots exept the last in string
   */
   static _removeExcessPoints(str) {
    const parts = str.split(".");

    if (parts.length > 2) {
      const lastPart = parts.pop();
      return parts.join("") + "." + lastPart;
    }

    return str;
  }
}
